<template>
	<div class="ESelectBox">
		<div class="tit">{{Language.LG.SelBoxTit[isLanguage]}}</div>
		<div class="table">
			<div class="list">
				<div class="item">{{Language.LG.BoxSize[isLanguage]}}</div>
				<div class="item">{{Language.LG.SmallBox[isLanguage]}}</div>
				<div class="item">{{Language.LG.MedBox[isLanguage]}}</div>
				<div class="item">{{Language.LG.BigBox[isLanguage]}}</div>
			</div>
			<div class="list">
				<div class="item">{{Language.LG.BoxNum[isLanguage]}}</div>
				<!-- <div class="item">{{boxNum.Small}}</div>
				<div class="item">{{boxNum.Medium}}</div>
				<div class="item">{{boxNum.Large}}</div> -->
				<div class="item" v-for="(num,index) in boxNum" :key="index">{{num.key}}</div>
			</div>
			<div class="confirmBtn" @click="ToWarehousList()">
				<div class="cFlex">
					<span>{{Language.LG.CheckInBox[isLanguage]}}</span>
				</div>
			</div>
		</div>
		
		<div class="RadioBox">
			<label class="label">{{Language.LG.SelectBox[isLanguage]}}</label>
			<!-- <radio-group @change="RadioChange">
				<label class="radio" v-for="(num,index) in boxNum" :key="index">
					<radio :value="num.id" :disabled="num.disabled"/>{{num.name}}
				</label>
			</radio-group> -->
			<el-radio-group v-model="boxInfo">
				<el-radio v-for="(num,index) in boxNum" :key="index" :label="num.id" :disabled="num.disabled">{{num.name}}</el-radio>
			</el-radio-group>
		</div>
		<div class="SelBtn">
			<button class="subBtn" @click="ToScan()">{{Language.LG.Confirm[isLanguage]}}</button>
		</div>
		
		<!--超时组件-->
		<overTime :callBack="backUp"></overTime>
		<!--按钮组-->
		<EConfigBtn :pushBg="'#151c36'" :backUp="backUp" :quit="quit"></EConfigBtn>
		<!--loading -->
		<ELoading v-if="isLoading" :LoadingType="'2'"></ELoading>
	</div>
</template>

<script>
	import overTime from '../assets/overTime.vue'
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import ELoading from '../assets/Loading.vue'
	import { EloginApi } from '../../../../static/CESite40s/js/api.js'
	import { conLog,storage } from '../../../../static/js/utils/utility.js'
	var vm
	export default {
		data() {
			return {
				configStorage:null,
				
				isLanguage:0,
				Language:'',
				
				boxInfo:'',//当前选中
				//箱格各自数量
				boxNum:[{
					id:'5',
					key:0,
					name:'',
					disabled:true,
				},{
					id:'6',
					key:0,
					name:'',
					disabled:true,
				},{
					id:'7',
					key:0,
					name:'',
					disabled:true,
				}],
				
				isLoading:false,
			};
		},
		async created(){
			vm = this
			var configStorage = storage.localGetItem('configStorage');
			if(configStorage){
				this.configStorage = configStorage
			}
			
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
			
			this.$store.state.overTime = 80
			
			//暂时的
			this.boxNum[0].name = this.$Language.LG.SmallBoxRd[vm.isLanguage]
			this.boxNum[1].name = this.$Language.LG.MedBoxRd[vm.isLanguage]
			this.boxNum[2].name = this.$Language.LG.BigBoxRd[vm.isLanguage]
			
			this.BoxAmountInfo()
		},
		components:{
			overTime,
			EConfigBtn,
			ELoading
		},
		methods:{
			//获取设备剩余箱柜信息
			async BoxAmountInfo(){
				let data = {
					'cabinet_id': vm.configStorage.deviceId
				}
				const res = await EloginApi.BoxAmountInfo(data)
				conLog('箱格信息',res)
				if(res){
					if(res.meta.code==200){
						var arr = res.body.free_box_count
						vm.boxNum=[]
						var obj_s={
							id:'5',
							key:arr.box_s,
							name:vm.$Language.LG.SmallBoxRd[vm.isLanguage],
							disabled:arr.box_s==0 ? true : false,
						}
						vm.boxNum.push(obj_s)
						
						var obj_m={
							id:'6',
							key:arr.box_m,
							name:vm.$Language.LG.MedBoxRd[vm.isLanguage],
							disabled:arr.box_m==0 ? true : false,
						}
						vm.boxNum.push(obj_m)
						
						var obj_l={
							id:'7',
							key:arr.box_l,
							name:vm.$Language.LG.BigBoxRd[vm.isLanguage],
							disabled:arr.box_l==0 ? true : false,
						}
						vm.boxNum.push(obj_l)
						
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//去入库清单
			ToWarehousList(){
				this.isLoading = true
				setTimeout(function(){
					vm.$router.push({
						path:'/CEsite40s/EWarehousList',
						query:{
							'type':'1'
						}
					})
				},2000)
			},
			//选择好箱格,去扫码
			ToScan(){
				if(vm.boxInfo == ''){
					vm.$message({
						message: '请选择箱格大小',
						type: 'error',
						duration:1000
					});
					return
				}
				this.isLoading = true
				setTimeout(function(){
					vm.$router.push({
						path:'/CEsite40s/EScanCode',
						query:{
							'boxInfo':vm.boxInfo
						}
					})
				},2000)
			},
			//返回上一页
			backUp(){
				vm.$router.push({
					path:'/CEsite40s/ELogin'
				})
			},
			//退出登录
			quit(){
				vm.$router.push({
					path:'/CEsite40s'
				})
			}
		},
	}
</script>

<style lang="less">
.ESelectBox{
	height: 100vh;
	background: #f2f2f2;
	color: #151c36;
	text-align: center;
	.SelBtn{
		margin-top: 0.3rem;
		.subBtn{
			display: inline-block;
			line-height: 1 !important;
			padding: 0.3rem 0.5rem;
			border-radius: 0.15rem;
			background: #151c36;
			font-size: 0.3rem;
			color: #fff;
		}
	}
	.RadioBox{
		width: 50%;
		margin: 0 auto;
		display: flex;
		align-items: center;
		.el-radio{
			font-size:0.36rem;
			.el-radio__label{
				font-size: 0.36rem;
				padding-left: 0.1rem;
				color: #666;
			}
			.el-radio__inner{
				width: 0.36rem;
				height: 0.36rem;
				border: 0.01rem solid #999;
				&:after{
					content: "";
					width: 0.1rem;
					height: 0.1rem;
				}
			}
		}
		// .el-radio{
		// 	font-size: 0.36rem;
		// 	margin-right: 0.2rem;
		// }
		.label{
			background: #151c36;
			color: #fff;
			width: 2.5rem;
			height: 0.8rem;
			line-height: 0.8rem;
			border-top-left-radius: 0.15rem;
			border-bottom-left-radius: 0.15rem;
			flex-shrink: 0;
			margin-right: 0.2rem;
			font-size: 0.26rem;
		}
	}
	.table{
		background: #fff;
		color: #151c36;
		font-size: 0.4rem;
		box-shadow: 0 0.02rem 0.03rem 0 rgba(0,0,0,.5);
		width: 50%;
		margin: 0 auto 0.2rem;
		border-radius: 0.1rem;
		position: relative;
		.confirmBtn{
			background:url(../../../../static/CESite40s/images/btn_blue_circle_normal.png) no-repeat;
			background-size: cover;
			width: 2.5rem;
			height: 2.5rem;
			color: #151c36;
			position: absolute;
			left: 110%;
			top:50%;
			margin-top: -1.25rem;
			border-radius: 50%;
			z-index: 10;
			.cFlex{
				width: 100%;
				height: 2.5rem;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 0.3rem;
				padding: 0 0.15rem;
				box-sizing: border-box;
			}
			&:active{
				background:url(../../../../static/CESite40s/images/btn_blue_circle_focus.png) no-repeat;
				background-size: cover;
			}
			.time{
				position: absolute;
				width: 100%;
				bottom: 0.4rem;
				left: 0;
				line-height: 1;
			}
		}
		.list{
			display: flex;
			align-items: center;
			border-bottom: 0.02rem solid #ddd;
			padding: 0.2rem 0;
			&:last-child{
				border-bottom: none;
			}
			.item{
				flex: 1;
				flex-shrink: 0;
				height: 1rem;
				line-height: 1rem;
				border-right: 0.02rem solid #ddd;
				&:last-child{
					border-right: none;
				}
			}
		}
	}
	.tit{
		padding: 0.8rem 0 0.2rem;
		font-size: 0.45rem;
		color: #151c36;
	}
	.overTime{
		color: #666;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CEsite40s/SelectBox/SelectBox.vue